export const getters = {
    activitiesInfo: state => state.activitiesInfo,
    classList: state => state.classes && state.classes.content,
    campsList: state => state.camps && state.camps.content,
    campPricing: state => state.campPricing,
    aftercareList: state => state.aftercareSessions && state.aftercareSessions.content,
    aftercareDay: state => state.aftercareDay,
    activity: state => state.activity,
    activitiesClassRequired: state => state.activitiesClassRequired,
    activitiesCampRequired: state => state.activitiesCampRequired,
    activitiesAftercareRequired: state => state.activitiesAftercareRequired,
    teachers: state => state.teachers || [],
    pickUps: state => state.pickUps || [],
    tShirtSizes: state => state.tShirtSizes,
    activityExtras: state => state.activityExtras,
    activityExtrasCamp: state => state.activityExtrasCamp || [],
    activityExtrasAftercare: state => state.activityExtrasAftercare || [],
    childRosterInfo: state => state.childRosterInfo || {},
    policies: state => state.policies,
    activitiesAftercareDropInFull: state => state.activitiesAftercareDropInFull,
    activityExtrasAftercareUses: state => state.activityExtrasAftercareWhichUsesBefore,
    activityForms: state => state.activityForms,
    activitiesAftercareRostersFreeDays: state => state.activitiesAftercareRostersFreeDays,
    activitiesAftercareWaitlistFreeDays: state => state.activitiesAftercareWaitlistFreeDays
};


// WEBPACK FOOTER //
// ./src/store/modules/activities/getters.js